import { jsx as _jsx } from "react/jsx-runtime";
import Flex from './Flex.js';
import {} from '@reservoir0x/relay-design-system/css';
const Skeleton = ({ css }) => {
    return (_jsx(Flex, { css: {
            animationName: 'pulse',
            backgroundColor: 'skeleton-background',
            borderRadius: 8,
            width: 100,
            height: 12,
            animation: 'pulse 3s ease-in-out infinite',
            ...css
        } }));
};
export default Skeleton;
//# sourceMappingURL=Skeleton.js.map